module.exports = __webpack_public_path__ + "static/media/vis3.cc51f8a8.jpeg";